import sandboxSlices from './sandbox';

const activitiesSlices = [sandboxSlices];

export default activitiesSlices;
